var _style, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAnimate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    @keyframes pulse {\r\n      0% { transform: scale(1); }\r\n      50% { transform: scale(1.1); }\r\n      100% { transform: scale(1); }\r\n    }\r\n    \r\n    @keyframes rotate {\r\n      from { transform: rotate(0deg); }\r\n      to { transform: rotate(360deg); }\r\n    }\r\n    \r\n    @keyframes fadeInOut {\r\n      0% { opacity: 0.3; }\r\n      50% { opacity: 1; }\r\n      100% { opacity: 0.3; }\r\n    }\r\n\r\n    .logo-circle { \r\n      animation: pulse 2s infinite ease-in-out;\r\n      transform-origin: center;\r\n    }\r\n    \r\n    .logo-paths { \r\n      animation: fadeInOut 3s infinite ease-in-out;\r\n      transform-origin: center;\r\n    }\r\n    \r\n    .logo-ellipse { \r\n      animation: rotate 4s infinite linear;\r\n      transform-origin: center;\r\n    }\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "logo-circle",
    opacity: 0.5,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "logo-paths"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 40C0 17.909 4.26 0 26.504 0C48.748 0 80.553 17.909 80.553 40C80.553 62.091 73.694 80 51.45 80C29.206 80 0 62.091 0 40Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.339 0C72.601 4.262 67.631 22.834 52.23 38.235C36.828 53.637 15.955 68.902 11.693 64.64C7.432 60.378 16.3 47.661 31.702 32.259C47.103 16.858 64.077 -4.262 68.339 0Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.547 80C38.62 83.464 27.813 75.212 22.175 54.173C16.538 33.134 18.259 0.145 31.186 -3.319C44.113 -6.783 54.07 7.425 59.708 28.464C65.345 49.503 64.474 76.536 51.547 80Z",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "logo-ellipse",
    cx: 40,
    cy: 40,
    rx: 15,
    ry: 15,
    fill: "url(#paint4_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 40,
    y1: 80,
    x2: 66.521,
    y2: 35.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 32.735,
    y1: 28.484,
    x2: 48.169,
    y2: 43.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 64.745,
    y1: 30.634,
    x2: 17.933,
    y2: 43.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 34) rotate(90) scale(20.528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#F89621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A45800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnimate);
export default __webpack_public_path__ + "static/media/LogoAnimate.7991b995fffb563b22f5424ce2503053.svg";
export { ForwardRef as ReactComponent };